module.exports = __webpack_public_path__ + "static/media/right_arrow_circle.db318164.svg";